import React from 'react';
import RecruitHeaderSectionImage2 from '../../assets/recruit_header_section_image2.svg';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/coomon.css';
import { useDeviceType } from '../../hooks/useDeviceType';

type BTImageInputProps = {
  hint?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const BTImageInput: React.FC<BTImageInputProps> = ({
  hint = '힌트를 입력하세요',
  value,
  onChange,
  onKeyDown
}) => {
  const { isMobile } = useDeviceType();

  return (
    <div style={styles.wrapper}>
      <img
        src={RecruitHeaderSectionImage2}
        alt="icon"
        style={{
          ...styles.icon,
          width: isMobile ? 12 : pxToRem(22),
          height: isMobile ? 12 : pxToRem(22),
        }}
      />
      <input
        type="text"
        placeholder={hint}
        className="bt-image-input"
        style={{ ...styles.input, fontSize: isMobile ? 14 : pxToRem(28) }}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid transparent',
    backgroundColor: 'transparent',
    padding: '8px 12px',
    fontFamily: '"LINE Seed Sans KR", sans-serif',
    width: '100%',
  } as React.CSSProperties,
  icon: {
    width: 22,
    height: 22,
    marginRight: 16,
    display: 'block',
  } as React.CSSProperties,
  input: {
    flex: 1,
    fontFamily: '"LINE Seed Sans KR", sans-serif',
    fontWeight: 400,
    fontSize: 28,
    lineHeight: '44px',
    height: '44px',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    color: 'black',
    padding: 0,
    placeholder: {
      color: '#B2B2B2',
    }
  } as React.CSSProperties,
};

export default BTImageInput;
